import { render, staticRenderFns } from "./CustomerSampleAnalyses.vue?vue&type=template&id=534bafd7&"
import script from "./CustomerSampleAnalyses.vue?vue&type=script&lang=js&"
export * from "./CustomerSampleAnalyses.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports